import React, { Component } from 'react'
import { apiProcess } from '../../../api/api'
import { userPhotoID } from '../../../../constants/images/sizesAndQuality'
import {
  CLOUDINARY_NAME,
  CLOUDINARY_USER_PRESET,
  CLOUDINARY_API_KEY,
} from '../../../../constants/images/cloudinary'
import {
  trackProfilePhotoChange,
  trackprofilePhotoChangeAttempt,
} from '../../../elements/tracking/accountTracking.js'
import * as Cookies from 'js-cookie'
import AppContainer from '../../../context/AppContainer'
import cloudinary from 'cloudinary-core'
import { Subscribe } from 'unstated'
import { PROFILE_PHOTO } from 'components/account/infoWizard/main/constants'
import { Header, Button } from 'components/elements'
import './../phone/phoneScreen.css'

const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY,
})

class ProfilePhotoScreen extends Component {
  constructor(props) {
    super(props)

    this.state = {
      profilePhoto: null,
      profilePhotoID: null,
      hasPhoto: false,
      photoLoading: false,
      generalError: false,
      updateProfilePhoto: function() {},
    }

    this.cloudWidget = window?.cloudinary?.createUploadWidget(
      {
        cloudName: CLOUDINARY_NAME,
        uploadPreset: CLOUDINARY_USER_PRESET,
        sources: ['local', 'facebook', 'instagram'],
        showAdvancedOptions: false,
        cropping: true,
        croppingShowBackButton: false,
        croppingAspectRatio: 1,
        croppingDefaultSelectionRatio: 0.85,
        multiple: false,
        defaultSource: 'local',

        styles: {
          palette: {
            window: '#ffffff',
            sourceBg: '#f4f4f5',
            windowBorder: '#90a0b3',
            tabIcon: '#000000',
            inactiveTabIcon: '#555a5f',
            menuIcons: '#555a5f',
            link: '#B9995A',
            action: '#339933',
            inProgress: '#0433ff',
            complete: '#339933',
            error: '#cc0000',
            textDark: '#000000',
            textLight: '#fcfffd',
          },
          fonts: {
            default: null,
            'sans-serif': {
              url: null,
              active: true,
            },
          },
        },
      },
      (err, result) => {
        if (!err) {
          if (result.event === 'success') {
            this.savePhoto(result.info.secure_url, result.info.public_id)
          }
          if (result.event === 'close') {
            this.setState({
              photoLoading: false,
            })
          }
        } else {
          this.props.onAttempt({
            attempt_desc: 'Uploaded Through Cloudinary Widget',
            error_message: 'Upload Error',
            error_code: 'Cloudinary Widget',
            error_type: 'Cloudinary Widget',
          })
          trackprofilePhotoChangeAttempt({
            parent: this.props.parentDescription,
            error_message: 'Upload Error',
            error_code: 'Cloudinary Widget',
            error_type: 'Cloudinary Widget',
          })

          this.setState({
            generalError: true,
            photoLoading: false,
          })
        }
      }
    )
  }

  componentDidMount() {
    this.props.onScreenLoad(PROFILE_PHOTO)
  }

  savePhoto = (newPhoto, publicID) => {
    let apiURL = 'users/profile_photo'

    let profileData = {
      secure_url: newPhoto,
      cloudinary_public_id: publicID,
    }

    apiProcess(
      apiURL,
      profileData,
      'update-profile-photo',
      'Upload Photo Wizard Step'
    )
      .then(
        function(responseData) {
          //show success banner.
          //clear all errors form. that includes birthdays
          this.setState({
            generalError: false,
            profilePhoto: newPhoto,
            profilePhotoID: publicID,
            hasPhoto: true,
            photoLoading: false,

            //SET PHOTO AVATAR COOKIE HERE.
          })

          Cookies.set('userAvatar', newPhoto)
          Cookies.set('userAvatarID', publicID)
          this.state.updateProfilePhoto()

          trackProfilePhotoChange({
            profile_photo: this.state.profilePhotoID,
          })
        }.bind(this)
      )
      .catch(
        function(responseData) {
          //show failure banner.

          this.setState({
            generalError: true,
          })

          this.props.onAttempt({
            attempt_desc: 'Uploaded Through Cloudinary Widget',
            error_message: 'n/a',
            error_code: 'n/a',
            error_type: 'Submission - Server',
          })
          trackprofilePhotoChangeAttempt({
            parent: this.props.parentDescription,
            error_message: 'n/a',
            error_code: 'n/a',
            error_type: 'Submission - Server',
          })
        }.bind(this)
      )
  }

  loadUploadWidget = (updateAuth) => {
    this.setState({
      photoModalLoading: true,
      updateProfilePhoto: updateAuth,
    })

    this.cloudWidget.open()
    this.setState({
      photoLoading: true,
      generalError: false,
    })
  }

  render() {
    const { profilePhotoID, photoLoading, hasPhoto, generalError } = this.state

    return (
      <Subscribe to={[AppContainer]}>
        {(auth) => {
          return (
            <React.Fragment>
              <div className="has-text-centered">
                {generalError && (
                  <div className="has-text-danger">
                    We are having problems right now.
                  </div>
                )}
                {!hasPhoto && (
                  <div>
                    <Header
                      size={4}
                      renderas="h2"
                      className="has-text-weight-bold"
                    >
                      Add a profile photo
                    </Header>
                    <Header size={6} subtitle>
                      Make sure we can see your face!
                    </Header>
                    <figure className="has-image-centered image is-128x128 mb-4">
                      <img
                        width="300px"
                        height="300px"
                        src={cl.url(userPhotoID(null), {
                          gravity: 'center',
                          height: 300,
                          width: 300,
                          crop: 'fill',
                          format: 'jpg',
                          quality: 80,
                        })}
                        className="is-rounded"
                        alt="Profile"
                      />
                    </figure>
                  </div>
                )}
                {hasPhoto && (
                  <div>
                    <Header
                      renderas="h2"
                      size={4}
                      className="has-text-weight-bold"
                    >
                      Lookin' ready to ride!
                    </Header>
                    <figure className="has-image-centered image is-128x128 mb-4">
                      <img
                        width="300px"
                        height="300px"
                        className="is-rounded"
                        src={cl.url(profilePhotoID, {
                          gravity: 'center',
                          height: 300,
                          width: 300,
                          crop: 'fill',
                          format: 'jpg',
                          quality: 80,
                        })}
                        alt="Profile"
                      />
                    </figure>
                  </div>
                )}
                {!hasPhoto && (
                  <div>
                    <Button
                      icon="upload" //leave these here and let's
                      disabled={photoLoading}
                      loading={photoLoading}
                      color="primary"
                      onClick={() =>
                        this.loadUploadWidget(auth.updateProfilePhoto)
                      }
                    >
                      Upload Photo
                    </Button>
                    {this.props.skippable && (
                      <span
                        className="is-block has-text-centered is-size-7 mt-1 is-clickable mt-2 finger-pointer"
                        onClick={() => this.props.onSkip()}
                      >
                        I'll do this later
                      </span>
                    )}
                  </div>
                )}
                {hasPhoto && (
                  <div>
                    <Button
                      icon="upload"
                      color="primary"
                      onClick={() => this.props.onSuccess()}
                    >
                      Continue
                    </Button>
                    <div>
                      <button
                        className="button is-white is-small mt-3"
                        onClick={() =>
                          this.setState({
                            profilePhoto: null,
                            hasPhoto: false,
                          })
                        }
                      >
                        Change Photo
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </React.Fragment>
          )
        }}
      </Subscribe>
    )
  }
}

export default ProfilePhotoScreen

ProfilePhotoScreen.defaultProps = {
  onSuccess: function() {},
  skippable: true,
  onAttempt: function() {},
  stepNumber: 0,
  parentDescription: 'Missing',
  onScreenLoad: function() {},
}
